<script setup>
import { onMounted, onUnmounted } from 'vue';


const props = defineProps({
  goodsFavName: {
    type: String,
    required: true
  }
});
const emit = defineEmits(['hidden']);

let modalEl = null;

const handleModalHidden = () => {
  emit('hidden');
}

const handleCloseClick = (event) => {
  event.target.blur();
}

onMounted(() => {
  modalEl = document.getElementById('deleteFromFavoriteCompleteModal');
  if (modalEl) {
    modalEl.addEventListener('hidden.bs.modal', handleModalHidden);

    modalEl.addEventListener('hide.bs.modal', () => {
      if(document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
    })
  }
})

onUnmounted(() => {
  if(modalEl) {
    modalEl.removeEventListener('hidden.bs.modal', handleModalHidden);
  }
})
</script>

<template>
  <div class="modal com_modal2 fade" id="deleteFromFavoriteCompleteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_c_check1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0">ご指定の商品を「{{ props.goodsFavName }}」から削除しました</h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1 wd2" data-bs-dismiss="modal" @click="handleCloseClick">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>
